import { getFirstDayOfCurrentMonth, parseLocalDateString, toLocalDateString } from "@/shared/lib/dates";
import { useEffect, useState, useCallback } from "react";
import { useDashboard } from "../../../lib/useDashboard";

export const useDateStart = () => {
  const { dateStart, dateEnd, setDateStart } = useDashboard();
  const [dateStartDate, setDateStartDate] = useState<Date | null>(null);
  const [pickerType, setPickerType] = useState<'year' | 'quarter' | 'month' | 'day'>('day');

  function getPeriodDate(date: Date, type: 'year' | 'quarter' | 'month' | 'day', position: 'start' | 'end' | 'value'): Date {
    const d = new Date(date);
    if (type === 'year') {
      if (position === 'start') return new Date(d.getFullYear(), 0, 1, 0, 0, 0, 0);
      if (position === 'end') return new Date(d.getFullYear(), 11, 31, 23, 59, 59, 999);
    }
    if (type === 'quarter') {
      const quarter = Math.floor(d.getMonth() / 3);
      if (position === 'start') return new Date(d.getFullYear(), quarter * 3, 1, 0, 0, 0, 0);
      if (position === 'end') {
        const endMonth = quarter * 3 + 2;
        return new Date(d.getFullYear(), endMonth + 1, 0, 23, 59, 59, 999);
      }
    }
    if (type === 'month') {
      if (position === 'start') return new Date(d.getFullYear(), d.getMonth(), 1, 0, 0, 0, 0);
      if (position === 'end') return new Date(d.getFullYear(), d.getMonth() + 1, 0, 23, 59, 59, 999);
    }
    // day
    if (position === 'start') return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);
    if (position === 'end') return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999);
    return d;
  }

  useEffect(() => {
    if (!dateStart) {
      const localStorageValue = localStorage.getItem("dateStart");
      if (localStorageValue) {
        setDateStart(localStorageValue);
        setDateStartDate(parseLocalDateString(localStorageValue));
      } else {
        const firstDay = getFirstDayOfCurrentMonth();
        setDateStart(toLocalDateString(firstDay));
        setDateStartDate(firstDay);
        localStorage.setItem("dateStart", toLocalDateString(firstDay));
      }
    } else {
      setDateStartDate(parseLocalDateString(dateStart));
      localStorage.setItem("dateStart", dateStart);
    }
  }, [dateStart, setDateStart]);

  const setValue = useCallback((date: Date | null) => {
    if (date) {
      const periodDate = getPeriodDate(date, pickerType, 'start');
      const str = toLocalDateString(periodDate);
      if (dateEnd && str > dateEnd) return;
      setDateStart(str);
      localStorage.setItem("dateStart", str);
    } else {
      setDateStart("");
      localStorage.removeItem("dateStart");
    }
  }, [setDateStart, pickerType, dateEnd]);

  return {
    value: dateStartDate,
    setValue,
    pickerType,
    setPickerType
  };
}